import {useQuery,useMutation} from "@1f/react-sdk";
import sharedDatasInstance from "../sharedDatas";
import { query_downloadAllegato, query_getAllegati } from "../query/allegatoQueries";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { createAllegatoModel } from "../helpers/modelHelpers";
import { mutation_deleteAllegato, mutation_uploadAllegato } from "../mutations/allegatiMutations";

export const AllegatiApi = () => {
    const errorApiHelpers = apiErrorHelper();
    const apiAllegatiByEntity = useQuery(
        query_getAllegati,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiDownloadAllegatoById = useQuery(
        query_downloadAllegato,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiUploadAllegato = useMutation(
        mutation_uploadAllegato,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    ) 
    const apiDeleteAllegato = useMutation(
        mutation_deleteAllegato,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )

    const UploadAllegato = async (fileBase64, contentType, tenantId, aziendaId, entityType) => {
        try {
            let uploadResponse = await apiUploadAllegato.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                entityType: entityType,
                dataInput: {
                    file_base64: fileBase64,
                    content_type: contentType
                }
            });
            if(uploadResponse && uploadResponse.data){
                return uploadResponse.data.data.uploadAttachment;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore nel caricamento dell'allegato");
        }
    }
    const GetAllegati = async (fascicoloId,tenantId,aziendaId) => {
        // Validazione input prima della chiamata: evita richieste con tenant/azienda/fascicolo vuoti o non validi (PARS-1515)
        const fascicoloIdNum = Number(fascicoloId);
        const aziendaIdNum = Number(aziendaId);
        if (!tenantId || !Number.isInteger(fascicoloIdNum) || fascicoloIdNum <= 0 || !Number.isInteger(aziendaIdNum) || aziendaIdNum <= 0) {
            throw new Error("Parametri non validi per il recupero degli allegati");
        }
        try {
            let allegatiResponse = await apiAllegatiByEntity.fetch({
                fascicoloId: fascicoloIdNum,
                tenantId: tenantId,
                aziendaId: aziendaIdNum
            })
            if(allegatiResponse && allegatiResponse.data){
                return allegatiResponse.data.data.getAllegati.map((item) => createAllegatoModel(item,tenantId))
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore nel recupero degli allegati");
        }
    };
    const DownloadAllegatoBase64 = async (allegatoId,tenantId,aziendaId) => {
        try {
            let allegatoResponse = await apiDownloadAllegatoById.fetch({
                allegatoId: allegatoId,
                tenantId: tenantId,
                aziendaId: aziendaId
            })
            if(allegatoResponse && allegatoResponse.data){
                return allegatoResponse.data.data.downloadAllegato.fileBase64;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore nel download dell'allegato");
        }
    }
    const DeleteAllegato = async (allegatoId, tenantId, aziendaId) => {
        try {
            let deleteResponse = await apiDeleteAllegato.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                allegatoId: allegatoId,
            });
            if(deleteResponse && deleteResponse.data){
                return deleteResponse.data.data.deleteAttachment.success;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore nella cancellazione dell'allegato");
        }
    }

    return { 
        UploadAllegato,
        GetAllegati,
        DownloadAllegatoBase64,
        DeleteAllegato
    };
};
